import React from 'react'

class Loader extends React.Component{
    render(){
        return(
            <div className="col-lg-12 text-center">
                <img src="/image/Pulse-0.6s-131px.svg" style={{height: '75px'}} className="text-center" alt="loaderImage" />
            </div>
        )
    }
}

export default Loader;